import Radio from 'components/Form/RadioButtonType'
import { RadioGroupNew } from '../DrawerStyle'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
//importing components
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import Uploadloader from '../../../../Uploader'
import { Checkbox } from 'antd'
import Control from 'components/Control/Control'
import Divider from 'components/Divider/Divider'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/StudentSelect.js'
import AntdSelectNew from 'components/Form/SelectNew'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import { MonthList } from 'modules/OnBoarding/Register/Education/constant'
import { StyledFormItem } from 'modules/OnBoarding/Register/Education/style'
import { getDesignationsList, searchAPI } from 'modules/OnBoarding/actions'
import {
  Container,
  FormItem,
  Heading,
  IconView,
  SubHeading,
} from '../EducationDetailStyle'
import WorkExpAwardForm from './WorkExpAwardForm'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { searchConfig } from 'utils/config'
import Date from 'components/Date/Date'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 14px;
  margin-left: 6px;
`

const LabelWithPending = ({ children, isPending }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Label>{children}</Label>
    {isPending && <PendingIcon />}
  </div>
)

const ProjectForm = ({
  form,
  formName,
  onRemove,
  studentFormData,
  listOfStudentSkills,
  isPresent,
  setIsPresent,
  AllCollegeList,
  setInstituteCampusName,
  instituteCampusValue,
  organizationId,
  setOrganizationId,
  corporateName,
  setCorporateName,
  setCorporateId,
  corporateId,
  getListOfSkills,
  setIsUpdateButtonEnabled,
  setSkillLoading,
  skillLoading,
  listOfSkills,
  SkillsAPI,
  isExpUpdated,
  frozenFields = {},
  pendingFields = {},
  isNew = false,
}) => {
  console.log('pendingFields', pendingFields)
  const dispatch = useDispatch()
  const [show, setShow] = useState(true)
  const [projectTitle, setProjectTitle] = useState(
    form.getFieldValue([[formName], 'title'])
  )
  const roleList = useSelector(state => state?.studentData?.designationList)
  const [roleName, setRoleName] = useState('')
  const [timeLine, setTimeLine] = useState('')
  const [startDate, setStartDate] = useState()
  const [startMonth, setStartMonth] = useState()
  const [startYear, setStartYear] = useState()
  const [endDate, setEndDate] = useState()
  const [endMonth, setEndMonth] = useState()
  const [funtionName, setFunctionName] = useState('')
  const [industryName, setIndustryName] = useState('')
  const [endYear, setEndYear] = useState()
  const [roleSearch, setRoleSearch] = useState('')
  const [options, setOptions] = useState([])
  const [noticePeriod, setNoticePeriod] = useState()
  const [skillErrorMsg, setSkillErrorMsg] = useState('')
  const [functionSearchList, setFunctionSearchList] = useState([])
  const [industrySearchList, setIndustrySearchList] = useState([])
  const [companySearchList, setCompanySearchList] = useState([])
  const [functionSearch, setFunctionSearch] = useState('')
  const [optionsFunction, setOptionsFunction] = useState([])
  const [compSearch, setCompSearch] = useState('')

  const [description, setDescription] = useState(
    form.getFieldValue([[formName], 'description']) || ''
  )
  const [isJobType, setIsJobType] = useState(
    form.getFieldValue([[formName], 'jobType'])
  )
  const [selectedSkill, setSelectedSkill] = useState([])
  const [award, setAward] = useState([])
  const [awardList, setAwardList] = useState([])

  const [file, setFile] = useState(
    form.getFieldValue([[formName], 'certificate'])
  )
  const [initialSkillState, setInitialSkillState] = useState([])
  const [storeSkill, setStoreSkill] = useState([])
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(
    form.getFieldValue([[formName], 'isCurrentlyWorking'])
      ? form.getFieldValue([[formName], 'isCurrentlyWorking'])
      : false
  )
  const [dateErrorMsg, setDateErrorMsg] = useState('')
  const [workErrorMsg, setWorkErrorMsg] = useState('')
  const currentYear = moment().year()
  const years = []
  for (let year = currentYear; year >= 1923; year--) {
    years.push({
      value: year,
      name: year,
    })
  }

  const RadioOptions = [
    {
      id: 1,
      label: 'Full-time',
      value: 'FULL_TIME',
    },
    {
      id: 2,
      label: 'Part-time',
      value: 'PART_TIME',
    },
  ]

  // useEffect(() => {
  //   if (functionSearchList.length === 0) {
  //     setFunctionSearchList([
  //       {
  //         name: 'Other',
  //         id: 'OTHER',
  //         isActive: 'true',
  //       },
  //       ...functionSearchList,
  //     ])
  //   }
  // }, [functionSearchList])
  useEffect(() => {
    if (industrySearchList.length === 0) {
      setIndustrySearchList([
        {
          name: 'Other',
          id: 'OTHER',
          isActive: 'true',
        },
        ...industrySearchList,
      ])
    }
  }, [industrySearchList])
  useEffect(() => {
    const cert = form.getFieldValue([[formName], 'certificate'])

    if (cert && cert.id) {
      setFile({
        id: cert.id,
        name: 'Uploaded Certificate',
        isUploaded: true,
      })
    } else {
      setFile(null)
    }
  }, [formName])


  useEffect(() => {
    if (roleList?.list) {
      setOptions(roleList?.list)
    }
  }, [roleList?.list])

  useEffect(() => {
    if (form.getFieldValue([[formName], 'started_in']) != undefined) {
      const startedInValue = form.getFieldValue([[formName], 'started_in'])
      const dateParts = startedInValue.split('/')
      if (dateParts.length === 2) {
        const momentDate = moment(startedInValue, 'MM/YYYY', true)
        if (momentDate.isValid()) {
          setStartMonth(dateParts[0])
          setStartYear(dateParts[1])
          form.setFieldsValue({ [formName]: { startMonth: dateParts[0] } })
          form.setFieldsValue({ [formName]: { startYear: dateParts[1] } })
          setStartDate(momentDate)
        } else {
          setStartDate(null)
          form.setFieldsValue({ [formName]: { started_in: '' } })
        }
      }
    }
    if (form.getFieldValue([[formName], 'ended_in']) != undefined) {
      const endedInValue = form.getFieldValue([[formName], 'ended_in'])
      const dateParts = endedInValue.split('/')
      if (dateParts.length === 2) {
        const momentDate = moment(endedInValue, 'MM/YYYY', true)
        if (momentDate.isValid()) {
          setEndMonth(dateParts[0])
          setEndYear(dateParts[1])
          form.setFieldsValue({ [formName]: { endMonth: dateParts[0] } })
          form.setFieldsValue({ [formName]: { endYear: dateParts[1] } })
          setEndDate(momentDate)
        } else {
          setEndDate(null)
          form.setFieldsValue({ [formName]: { ended_in: '' } })
        }
      }
    }
    if (form.getFieldValue([[formName], 'noticePeriod']) != undefined) {
      setNoticePeriod(form.getFieldValue([[formName], 'noticePeriod']))
    }
    setIsCurrentlyWorking(
      form.getFieldValue([[formName], 'isCurrentlyWorking'])
    )
  }, [form.getFieldValue([[formName], 'started_in']), form.getFieldValue([[formName], 'ended_in'])])

  useEffect(() => {
    setAwardList(form.getFieldValue([[formName], 'awards']))
  }, [])
  useEffect(() => {
    let listData = []
    if (awardList !== undefined && awardList !== null) {
      awardList.filter(data => data != null).forEach((data, index) => {
        let formName1 = formName + '_award_' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description || ''
        form.setFieldsValue({
          [formName1]: {
            title: data?.title,
            awarded_on: data?.awarded_on,
            description: formattedDescription,
            certificate: data?.certificate,
          },
        })
        listData.push({
          component: WorkExpAwardForm,
          formName: formName1,
        })
      })

      setAward(listData)
    }
  }, [awardList])

  useEffect(() => {
    let updatedList = []
    let formDatas = form.getFieldValue()
    Object.entries(formDatas).forEach(([name, item], index) => {
      if (name.includes('award') && name.includes(formName)) {
        form.setFieldValue({
          [name]: {
            ...item,
          },
        })
        updatedList.push({
          component: WorkExpAwardForm,
          formName: name,
        })
      }
    })

    setAward(updatedList)
  }, [isExpUpdated])

  const onBlurProjectTitle = e => {
    if (e.target.value.trim()) {
      form.setFieldsValue({ [formName]: { title: e.target.value?.trim() } })
      setProjectTitle(e.target.value?.trim())
    } else {
      form.setFieldsValue({ [formName]: { title: '' } })
      setProjectTitle('')
    }
  }

  const onBlurHandler = key => {
    if (!form.getFieldValue([[formName], [key]])?.trim()) {
      form.setFieldsValue({ [formName]: { [key]: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { [key]: form.getFieldValue([[formName], [key]])?.trim() },
      })
    }
  }

  const validatorEndDate = (rule, value) => {
    const now = moment()

    // Get the form values directly
    const start = form.getFieldValue([[formName], 'started_in'])
    const end = form.getFieldValue([[formName], 'ended_in'])
    console.log(start, end, 'Started')
    // Future date check for start date
    if (start && moment(start, 'MM/YYYY').isAfter(now)) {
      setDateErrorMsg('Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject('Start Date cannot be in the future')
    }
    // Only prevent same dates for experience, not for internships
    // if (start === end && start && end && !formName?.includes('internship')) {  
    // setDateErrorMsg('Start Date cannot be same as End Date')
    //   form.setFieldsValue({
    //     [formName]: { error: 'Start Date cannot be same as End Date' },
    //   })
    //   return Promise.reject('Start Date cannot be same as End Date')
    // }
    // Future date check for end date
    if (end && moment(end, 'MM/YYYY').isAfter(now)) {
      setDateErrorMsg('End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
      return Promise.reject('End Date cannot be in the future')
    }

    if (((start && !end) || (!start && end)) && !isCurrentlyWorking) {
      setDateErrorMsg('Please enter both Start and End dates')
      form.setFieldsValue({
        [formName]: { error: 'Please enter both Start and End dates' },
      })
      return Promise.reject('Please enter both Start and End dates')
    }
    // Only do the comparison if both dates exist
    if (start && end) {
      // Check if end date is before start date using moment
      if (moment(end, 'MM/YYYY').isBefore(moment(start, 'MM/YYYY'))) {
        setDateErrorMsg('End date cannot be before start date')
        form.setFieldsValue({
          [formName]: { error: 'End date cannot be before start date' },
        })
        return Promise.reject('End date cannot be before start date')
      }
    }

    setDateErrorMsg('')
    return Promise.resolve()
  }

  const workValidator = (rule, value) => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )
    const now = moment()

    const isStartMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'startMonth'])
      ) !== undefined
    const isStartYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'startYear'])
      ) !== undefined
    const isEndMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'endMonth'])
      ) !== undefined
    const isEndYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'endYear'])
      ) !== undefined

    if (
      form.getFieldValue([[formName], 'startMonth']) === undefined ||
      !isStartMonthInList
    ) {
      setWorkErrorMsg(' Please select StartMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select StartMonth' } })
    } else if (
      form.getFieldValue([[formName], 'startYear']) === undefined ||
      !isStartYearInList
    ) {
      setWorkErrorMsg(' Please select StartYear')
      form.setFieldsValue({ [formName]: { error: 'Please select StartYear' } })
    } else if (startDate > now) {
      setWorkErrorMsg(' Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
    } else if (
      (!isCurrentlyWorking &&
        form.getFieldValue([[formName], 'endMonth']) === undefined) ||
      (!isCurrentlyWorking && !isEndMonthInList)
    ) {
      setWorkErrorMsg(' Please select EndMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select EndMonth' } })
    } else if (
      (!isCurrentlyWorking &&
        form.getFieldValue([[formName], 'endYear']) === undefined) ||
      (!isCurrentlyWorking && !isEndYearInList)
    ) {
      setWorkErrorMsg(' Please select EndYear')
      form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
    } else if (
      !isCurrentlyWorking &&
      form.getFieldValue([[formName], 'endYear']) != undefined &&
      form.getFieldValue([[formName], 'endMonth']) != undefined &&
      endDate > now
    ) {
      setWorkErrorMsg(' End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
    } else if (
      !isCurrentlyWorking &&
      form.getFieldValue([[formName], 'endYear']) != undefined &&
      form.getFieldValue([[formName], 'endMonth']) != undefined &&
      endDate < startDate
    ) {
      setWorkErrorMsg('End date cannot be before start date')
      form.setFieldsValue({
        [formName]: { error: 'End date cannot be before start date' },
      })
    } else {
      setWorkErrorMsg('')
      return Promise.resolve()
    }
  }

  const onFunctionChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    if (data?.toUpperCase() === 'OTHER') {
      setFunctionName(null)
      form.setFieldsValue({ [formName]: { addFunction: 'OTHER' } })
      form.setFieldsValue({ [formName]: { function: '' } })
    } else {
      setFunctionName(data)
      form.setFieldsValue({
        [formName]: { addFunction: null },
      })
      form.setFieldsValue({ [formName]: { function: option?.option?.name } })
    }
  }

  const onStartMonthChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    setStartMonth(data)
    form.setFieldsValue({ [formName]: { startMonth: data } })
  }

  const onStartYearChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    setStartYear(data)
    form.setFieldsValue({ [formName]: { startYear: data } })
  }

  const onEndMonthChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    setEndMonth(data)
    form.setFieldsValue({ [formName]: { endMonth: data } })
  }

  const onEndYearChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    setEndYear(data)
    form.setFieldsValue({ [formName]: { endYear: data } })
  }

  const onRoleChange = data => {
    setIsUpdateButtonEnabled(false)
    setRoleName(data)
    form.setFieldsValue({ [formName]: { role: data } })
  }

  const onSkillChange = (value, id) => {
    let list = []
    let skillList = []

    for (const item of id) {
      list.push(item?.id)
      let obj = {
        name: item?.name,
        id: item?.id,
      }
      skillList.push(obj)
    }
    setSelectedSkill(list)
    setStoreSkill(skillList)

    form.setFieldsValue({ [formName]: { skill_set: skillList } })
    list.sort((a, b) => a.localeCompare(b))
    initialSkillState.sort((a, b) => a.localeCompare(b))
    const isDifferent =
      JSON.stringify(list) !== JSON.stringify(initialSkillState)
    setIsUpdateButtonEnabled(!isDifferent)
    delaySkillToFetch('')
    if (skillList.length > 20) {
      setSkillErrorMsg('Maximum 20 Skills only allowed')
    } else {
      // Clear the error message if skillList is within the limit
      setSkillErrorMsg('')
    }
  }

  const onChangeDescription = data => {
    if (
      (description == undefined &&
        data
          ?.replace(/<[^>]*>/g, '')
          ?.replace(/&nbsp;/g, ' ')
          ?.trim('') > 0) ||
      description?.toString('html') !== data?.toString('html')
    ) {
      setIsUpdateButtonEnabled(false)
      form.setFieldsValue({ [formName]: { description: data } })
      setDescription(data)
    }
  }

  const onIndustryChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    if (data?.toUpperCase() === 'OTHER') {
      setIndustryName(null)
      form.setFieldsValue({ [formName]: { addIndustry: 'OTHER' } })
      form.setFieldsValue({ [formName]: { industry: '' } })
    } else {
      setIndustryName(data)
      form.setFieldsValue({
        [formName]: { addIndustry: null },
      })
      form.setFieldsValue({ [formName]: { industry: option?.option?.name } })
    }
  }

  const getFormName = level => {
    let name = level?.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }

  const showHandler = () => {
    show ? setShow(false) : setShow(true)
    form.setFieldValue([[formName], 'shown'], show ? false : true)
  }

  const NoticePeriodList = []
  for (let year = 0; year <= 100; year++) {
    NoticePeriodList.push({
      value: year,
      name: year,
    })
  }

  const getTitle = formName => {
    if (formName?.includes('project')) {
      return 'Project'
    } else if (formName?.includes('internship')) {
      return 'Internship'
    } else if (formName?.includes('experience')) {
      return 'Experience'
    } else if (formName?.includes('course')) {
      return 'Course'
    }
  }
  useEffect(() => {
    form.setFieldValue([[formName], 'shown'], true)
    dispatch(getDesignationsList())
    dispatch(
      searchAPI(searchConfig?.function?.name, '', searchConfig?.function)
    )
      .then(results => setFunctionSearchList(results))
      .catch(error =>
        console.error(`Error searching ${searchConfig?.function?.name}:`, error)
      )
    dispatch(
      searchAPI(searchConfig?.industries?.name, '', searchConfig?.industries)
    )
      .then(results => setIndustrySearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.industries?.name}:`,
          error
        )
      )
    dispatch(
      searchAPI(
        searchConfig?.companyMaster?.name,
        '',
        searchConfig?.companyMaster
      )
    )
      .then(results => setCompanySearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.companyMaster?.name}:`,
          error
        )
      )
  }, [])
  useEffect(() => {
    setRoleName(form?.getFieldValue([[formName], 'role']))
    setIndustryName(form?.getFieldValue([[formName], 'industry']))
    setFunctionName(form?.getFieldValue([[formName], 'function']))
    setCorporateName &&
      setCorporateName(form?.getFieldValue([[formName], 'organization']))
    setCorporateId &&
      setCorporateId(form?.getFieldValue([[formName], 'corporateId']))
  }, [formName])

  useEffect(() => {
    let isSkillArray = Array.isArray(
      form?.getFieldValue([[formName], 'skill_set'])
    )
    if (isSkillArray) {
      setSelectedSkill(
        form?.getFieldValue([[formName], 'skill_set'])
          ? form
            ?.getFieldValue([[formName], 'skill_set'])
            ?.map(({ id }) => id) || []
          : []
      )
      setStoreSkill(
        form?.getFieldValue([[formName], 'skill_set'])
          ? form?.getFieldValue([[formName], 'skill_set'])
          : []
      )
      setInitialSkillState(
        form?.getFieldValue([[formName], 'skill_set'])
          ? form
            ?.getFieldValue([[formName], 'skill_set'])
            ?.map(({ id }) => id) || []
          : []
      )
    }
  }, [])

  useEffect(() => {
    const cert = form.getFieldValue([[formName], 'certificate'])
    setFile(cert || null)
  }, [formName])
  // useEffect(() => {
  //   form.setFieldsValue({ [formName]: { jobType: isJobType } })
  // }, [isJobType])

  useEffect(() => {
    if ((startDate && endDate) || isCurrentlyWorking) {
      setTimeLine(
        `${moment(
          form.getFieldValue([[formName], 'started_in']),
          'MM/YYYY'
        ).format('MMMM YYYY') +
        (isCurrentlyWorking
          ? '- Present'
          : endMonth
            ? '-' +
            moment(
              form.getFieldValue([[formName], 'ended_in']),
              'MM/YYYY'
            ).format('MMMM YYYY')
            : '')
        }`
      )
    }
  }, [startDate, endDate, isCurrentlyWorking])

  useEffect(() => {
    if (startMonth && startYear) {
      let date = startMonth + '/' + startYear
      form.setFieldsValue({ [formName]: { started_in: date } })
      setStartDate(date)
    }
  }, [startMonth, startYear])

  useEffect(() => {
    if (endMonth && endYear) {
      let date = endMonth + '/' + endYear
      form.setFieldsValue({ [formName]: { ended_in: date } })
      setEndDate(date)
    }
  }, [endMonth, endYear])

  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      dispatch(
        searchAPI(
          searchConfig?.companyMaster?.name,
          compSearch,
          searchConfig?.companyMaster
        )
      )
        .then(results => setCompanySearchList(results))
        .catch(error =>
          console.error(
            `Error searching ${searchConfig?.companyMaster?.name}:`,
            error
          )
        )
    }, 500)
    return () => clearTimeout(getData)
  }, [compSearch])

  useEffect(() => {
    if (compSearch) {
      const lowercaseCompSearch = compSearch?.toLowerCase()
      if (lowercaseCompSearch?.length > 0) {
        if (
          !companySearchList?.some(option => {
            const lowercaseOptionName = option?.companyName?.toLowerCase()
            return lowercaseOptionName === lowercaseCompSearch
          })
        ) {
          setCompanySearchList(prev => [
            { companyName: compSearch, id: '' },
            ...prev,
          ])
        }
      }
    }
  }, [compSearch, companySearchList])

  const awardHandle = (isAdd, isDelete, deleteForm) => {
    let awardLength = award?.length

    let arr = []
    let formName1 = formName + '_award_' + awardLength
    if (isAdd) {
      form.setFieldsValue({ [formName1]: null })
      arr.push({ component: WorkExpAwardForm, formName: formName1 })

      setAward(exp => exp.concat(arr))
      setIsUpdateButtonEnabled(false)
    }
    if (isDelete) {
      form.setFieldsValue({
        [deleteForm]: null,
      })
      let updatedList = []
      award
        ?.filter(data => data?.formName !== deleteForm)
        .forEach((item, index) => {
          let formName1 = formName + '_award_' + index
          let currentFormValue = form.getFieldValue([item.formName])
          form.setFieldsValue({
            [item.formName]: null,
          })
          form.setFieldsValue({
            [formName1]: {
              ...currentFormValue,
            },
          })
          updatedList.push({
            component: WorkExpAwardForm,
            formName: formName1,
          })
        })

      setAward(updatedList)

      setIsUpdateButtonEnabled(false)
    }
  }

  const delayFunctionToFetch = useCallback(
    debounce(data => {
      form.setFieldValue([[formName], 'function'], '')
      dispatch(
        searchAPI(searchConfig?.function?.name, data, searchConfig?.function)
      )
        .then(results => setFunctionSearchList(results))
        .catch(error =>
          console.error(
            `Error searching ${searchConfig?.function?.name}:`,
            error
          )
        )
    }, 500),
    []
  )
  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      await functionSearching(functionSearch)
    }, 500)
    return () => clearTimeout(getData)
  }, [functionSearch])

  const functionSearching = async (functionSearch) => {
    dispatch(
      searchAPI(searchConfig?.function?.name, functionSearch, searchConfig?.function)
    )
      .then(results => setFunctionSearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.function?.name}:`,
          error
        )
      )
  }
  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      dispatch(getDesignationsList(roleSearch))
    }, 500)
    return () => clearTimeout(getData)
  }, [roleSearch])

  useEffect(() => {
    if (roleSearch) {
      const lowercaseRoleSearch = roleSearch?.toLowerCase()
      if (roleSearch?.length > 0) {
        if (
          !options?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()
            return lowercaseOptionName === lowercaseRoleSearch
          })
        ) {
          setOptions(prev => [{ name: roleSearch, id: '' }, ...prev])
        }
      }
    }
  }, [roleSearch, options, roleList])
  useEffect(() => {
    if (functionSearch) {
      const lowercaseFunctionSearch = functionSearch?.toLowerCase()
      if (functionSearch?.length > 0) {
        if (
          !optionsFunction?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()
            return lowercaseOptionName === lowercaseFunctionSearch
          })
        ) {
          setOptionsFunction(prev => [{ name: functionSearch, id: '' }, ...prev])
        }
      }
      form.setFieldsValue({ [formName]: { function: '' } })
    }
  }, [functionSearch, optionsFunction, functionSearchList])
  useEffect(() => {
    setOptionsFunction(functionSearchList)
  }, [functionSearchList])
  const delayIndustryToFetch = useCallback(
    debounce(data => {
      form.setFieldValue([[formName], 'industry'], '')

      dispatch(
        searchAPI(
          searchConfig?.industries?.name,
          data,
          searchConfig?.industries
        )
      )
        .then(results => setIndustrySearchList(results))
        .catch(error =>
          console.error(
            `Error searching ${searchConfig?.industries?.name}:`,
            error
          )
        )
    }, 500),
    []
  )
  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const isCurrentlyOnChange = data => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )

    const now = moment()
    setIsUpdateButtonEnabled(false)
    setIsCurrentlyWorking(data?.target?.checked)
    form.setFieldsValue({
      [formName]: {
        isCurrentlyWorking: data?.target?.checked,
      },
    })
    setIsPresent(data?.target?.checked)
    if (data?.target?.checked) {
      setEndYear('')
      setEndMonth('')
      setEndDate('')
      form.setFieldsValue({ [formName]: { endYear: '' } })
      form.setFieldsValue({ [formName]: { ended_in: '' } })
      form.setFieldsValue({ [formName]: { endMonth: '' } })
      if (
        form.getFieldValue([[formName], 'endYear']) === null ||
        form.getFieldValue([[formName], 'endMonth']) === null ||
        form.setFieldsValue({ [formName]: { ended_in: '' } }) ||
        endDate > now ||
        endDate < startDate
      ) {
        setWorkErrorMsg('')
        form.setFieldsValue({
          [formName]: { error: '' },
        })
      }
    } else if (!data?.target?.checked) {
      if (
        form.getFieldValue([[formName], 'endYear']) === '' ||
        form.getFieldValue([[formName], 'endYear']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndYear')
        form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      }
      if (
        form.getFieldValue([[formName], 'endMonth']) === '' ||
        form.getFieldValue([[formName], 'endMonth']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndMonth')
        form.setFieldsValue({ [formName]: { error: 'Please select EndMonth' } })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate > now
      ) {
        setWorkErrorMsg(' End Date cannot be in the future')
        form.setFieldsValue({
          [formName]: { error: 'End Date cannot be in the future' },
        })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate < startDate
      ) {
        setWorkErrorMsg('End date cannot be before start date')
        form.setFieldsValue({
          [formName]: { error: 'End date cannot be before start date' },
        })
      }
    }
  }

  const delaySkillToFetch = useCallback(
    debounce(data => {
      SkillsAPI(0, data)
    }, 500),
    []
  )

  const onNoticePeriodChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    setNoticePeriod(data)
    form.setFieldsValue({ [formName]: { noticePeriod: data } })
  }

  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      dispatch(
        searchAPI(
          searchConfig?.companyMaster?.name,
          compSearch,
          searchConfig?.companyMaster
        )
      )
        .then(results => setCompanySearchList(results))
        .catch(error =>
          console.error(
            `Error searching ${searchConfig?.companyMaster?.name}:`,
            error
          )
        )
    }, 500)
    return () => clearTimeout(getData)
  }, [compSearch])

  const validateSkill = (rule, value, callback) => {
    if (form?.getFieldValue([[formName], 'skill_set'])?.length > 20) {
      setSkillErrorMsg('')
      return Promise.reject(new Error('Maximum 20 Skills only allowed'))
    } else {
      return Promise.resolve()
    }
  }

  const jobTypeOnchange = data => {
    setIsUpdateButtonEnabled(false)
    if (data === false) {
      form.setFieldsValue({ [formName]: { jobType: '' } })
    }
    setIsJobType(data)
    form.setFieldsValue({ [formName]: { jobType: data } })
  }

  const countRichTextCharacters = richText => {
    // Remove HTML tags using a regular expression
    const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText?.length || 0 // Set to 0 if undefined

    return characterCount
  }

  const onCorporateChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    
    // Handle when option has company data
    if (option?.option?.companyName?.trimStart()) {
      setCorporateName(option?.option?.companyName)
      setCorporateId(option?.option?.id || '')
      form.setFieldsValue({
        [formName]: { organization: option?.option?.companyName },
      })
      form.setFieldsValue({ [formName]: { corporateId: option?.option?.id || '' } })
    } 
    // Handle when data is a string (company name without ID - from temporary option)
    else if (typeof data === 'string' && data?.trimStart()) {
      setCorporateName(data)
      setCorporateId('')
      form.setFieldsValue({
        [formName]: { organization: data },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })
    }
    // Handle clear/empty selection
    else {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })
      setCorporateName('')
      setCorporateId('')
    }
  }
  const onCorporateBlur = () => {
    if (!form.getFieldValue([[formName], 'organization'])?.trim()) {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })
      setCorporateName('')
      setCorporateId('')
    }
  }

  const handleInputChange = e => {
    setIsUpdateButtonEnabled(false)
  }

  const onDateChange = (date, dateString) => {
    form.setFieldsValue({ [formName]: { started_in: dateString } })
    setStartDate(dateString)
    setIsUpdateButtonEnabled(false)
  }

  const onDateChangeEnd = (date, dateString) => {
    form.setFieldsValue({ [formName]: { ended_in: dateString } })
    setEndDate(dateString)
    setIsUpdateButtonEnabled(false)
  }
  useEffect(() => {
    setProjectTitle(form.getFieldValue([[formName], 'title']))
  }, [form.getFieldValue([[formName], 'title'])])

  return (
    <>
      {!skillLoading && (
        <Container column flexStart>
          <FormItem name={[[formName], 'id']} hidden>
            <AntdInput />
          </FormItem>
          <FormItem name={[[formName], 'temp_id']} hidden>
            <AntdInput />
          </FormItem>
          <FormItem name={[[formName], 'isDelete']} hidden>
            <AntdInput />
          </FormItem>
          <FormItem name={[[formName], 'shown']} hidden>
            <AntdInput />
          </FormItem>

          <Control spaceBetween alignCenter>
            <Control column flexStart>
              <Control alignCenter gap="8px">
                <Heading style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>{projectTitle || getTitle(formName)}
                  {(() => {
                    const hasPendingFields = Object.keys(pendingFields || {}).length > 0
                    return isNew && hasPendingFields && <PendingIcon />
                  })()}
                </Heading>
              </Control>
              <SubHeading>{timeLine || 'Timeline'}</SubHeading>
            </Control>
            <Control gap="10px" flexEnd>
              <IconView onClick={() => onRemove(false, true, formName)}>
                <Delete />
              </IconView>
              <IconView onClick={() => showHandler()}>
                <Dropdown />
              </IconView>
            </Control>
          </Control>
          <StyledFormItem show={form.getFieldValue([[formName], 'shown'])}>
            <>
              <Divider />
              <Control row gap="20px" width="100%">
                {(formName?.includes('experience') || formName?.includes('internship')) && (
                  <Control top="20px" flexStart column width="49%">
                    <FormItem name={[[formName], 'role']}>
                      <div></div>
                    </FormItem>
                    <Label>Role *
                      {(() => {
                        return !isNew && pendingFields?.role !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                      })()}
                    </Label>
                    <AntdSelectNew
                      rules={[
                        {
                          required: true,
                          message: 'Please select Role!',
                        },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'role']}
                      OptionData={options}
                      valueParam="name"
                      nameParam="name"
                      disabled={frozenFields.role}
                      showSearch={true}
                      onChange={value => {
                        onRoleChange(value)
                      }}
                      value={form?.getFieldValue([[formName], 'role'])}
                      onSearch={data => setRoleSearch(data?.trim() ?? '')}
                      filterOption={false}
                      onBlur={() => onBlurHandler('role')}
                    />

                  </Control>
                )}
                {formName?.includes('course') && (
                  <Control top="20px" flexStart column >
                    <Label>Institute Name *
                      {(() => {
                        return !isNew && pendingFields?.organization !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                      })()}
                    </Label>
                    <AntdInput
                      placeholder="Eg. Indian Institute of technology"
                      name={[[formName], 'organization']}
                      maxLength={120}
                      disabled={frozenFields.organization}
                      rules={[
                        {
                          required: true,
                          min: 3,
                          max: 120,
                          message:
                            'Please enter institute name! Minimum 3 characters, Maximum 120 characters.',
                        },
                      ]}
                      onChange={handleInputChange}
                    />
                  </Control>
                )}

                {!formName?.includes('course') && (
                  <Fragment>
                    {/* <Control spaceBetween top="20px" gap="20px"> */}
                      <Control top = "20px" flexStart column width="49%">
                        <Label>
                          {!formName?.includes('project')
                            ? 'Company Name *'
                            : 'Company Name'}
                            {(() => {
                                return !isNew && (pendingFields?.organization || pendingFields?.companyName) !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                              })()}
                        </Label>
                        <FormItem name={[[formName], 'corporateId']} />
                        <FormItem name={[[formName], 'organization']} />
                        <AntdSelectNew
                          placeholder="Select Corporate"
                          name={[[formName], 'organization']}
                          nameParam="companyName"
                          valueParam="id"
                          OptionData={companySearchList}
                          disabled={frozenFields.organization}
                          rules={[
                            {
                              required: !formName?.includes('project'),
                              message: 'Please select the Corporate.',
                            },
                          ]}
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          onSearch={data => setCompSearch(data?.trim() ?? '')}
                          onChange={onCorporateChange}
                          value={form?.getFieldValue([[formName], 'organization'])}
                          onBlur={onCorporateBlur}
                          onClear={() => setCompSearch('')}
                        />
                      </Control>

                      {!(
                        formName?.includes('experience') ||
                        formName?.includes('internship')
                      ) && (
                          <Control top="20px" flexStart column width="49%">
                            <Label>
                              Project Title *
                              {(() => {
                                return !isNew && pendingFields?.title !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                              })()}
                            </Label>
                            <AntdInput
                              placeholder="Eg.Bharti.."
                              name={[[formName], 'title']}
                              maxLength={120}
                              disabled={frozenFields.title}
                              rules={[
                                {
                                  min: 3,
                                  max: 120,
                                  message:
                                    'Please enter project title! Minimum 3 characters, Maximum 120 characters.',
                                },
                                {
                                  required: true,
                                  message: 'Please enter the Project title.',
                                },
                              ]}
                              onBlur={onBlurProjectTitle}
                              onChange={handleInputChange}
                            />
                          </Control>
                        )}
                    {/* </Control> */}
                  </Fragment>
                )}



                {/* {formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <Label>Start Month*</Label>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'startMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Month!',
                          },
                          {
                            validator: workValidator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartMonthChange(value)
                          form.validateFields(
                            [[formName], 'startMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setWorkErrorMsg('')
                              } else {
                                setWorkErrorMsg(
                                  errors[[formName]].startMonth.errors[0]
                                    .message
                                )
                              }
                            }
                          )
                          workValidator(null, null)
                        }}
                        value={startMonth}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            .indexOf(input?.toLowerCase()) >= 0
                        }
                        disable={false}
                      />
                    </Control>
                    <Control flexStart column>
                      <Label> Start Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'startYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Year!',
                          },
                          {
                            validator: workValidator,
                          },
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartYearChange(value)
                          form.validateFields(
                            [[formName], 'startYear'],
                            (errors, values) => {
                              if (!errors) {
                                setWorkErrorMsg('')
                              } else {
                                setWorkErrorMsg(
                                  errors[[formName]].startYear.errors[0].message
                                )
                              }
                            }
                          )
                          workValidator(null, null)
                        }}
                        value={startYear}
                        allowClear={true}
                        showSearch={true}
                        disable={false}
                      />
                    </Control>
                  </Control>

                  <FormItem name={[[formName], 'started_in']} />

                  {(!isPresent || isCurrentlyWorking) && (
                    <Control spaceBetween top="20px" gap="20px">
                      <Control flexStart column></Control>
                      <Control flexStart column>
                        <Checkbox
                          onChange={isCurrentlyOnChange}
                          checked={isCurrentlyWorking}
                        >
                          {'I am currently working'}
                        </Checkbox>
                      </Control>
                    </Control>
                  )}

                  <FormItem name={[[formName], 'isCurrentlyWorking']} />

                  {!isCurrentlyWorking && (
                    <>
                      <Control spaceBetween top="20px" gap="20px">
                        <Control flexStart column>
                          <Label>End Month*</Label>
                          <AntdSelect
                            placeholder="Eg.March"
                            name={[[formName], 'endMonth']}
                            rules={[
                              {
                                required: true,
                                message: 'Please select Ended Month!',
                              },
                              {
                                validator: workValidator,
                              },
                            ]}
                            OptionData={MonthList}
                            valueParam="value"
                            nameParam="name"
                            onChange={value => {
                              onEndMonthChange(value)
                              form.validateFields(
                                [[formName], 'endMonth'],
                                (errors, values) => {
                                  if (!errors) {
                                    setWorkErrorMsg('')
                                  } else {
                                    setWorkErrorMsg(
                                      errors[[formName]].endMonth.errors[0]
                                        .message
                                    )
                                  }
                                }
                              )
                              workValidator(null, null)
                            }}
                            value={endMonth}
                            allowClear={true}
                            showSearch={true}
                            filterOption={(input, option) =>
                              option?.name
                                ?.toLowerCase()
                                .indexOf(input?.toLowerCase()) >= 0
                            }
                            disabled={
                              !form.getFieldValue([[formName], 'started_in'])
                            }
                          />
                        </Control>
                        <Control flexStart column>
                          <Label> End Year *</Label>
                          <AntdSelect
                            placeholder="Eg.2020"
                            name={[[formName], 'endYear']}
                            rules={[
                              {
                                required: true,
                                message: 'Please select Ended Year!',
                              },
                              {
                                validator: workValidator,
                              },
                            ]}
                            OptionData={years}
                            valueParam="value"
                            nameParam="name"
                            onChange={value => {
                              onEndYearChange(value)
                              form.validateFields(
                                [[formName], 'endYear'],
                                (errors, values) => {
                                  if (!errors) {
                                    setWorkErrorMsg('')
                                  } else {
                                    setWorkErrorMsg(
                                      errors[[formName]].endYear.errors[0]
                                        .message
                                    )
                                  }
                                }
                              )
                              workValidator(null, null)
                            }}
                            value={endYear}
                            allowClear={true}
                            showSearch={true}
                            disabled={
                              !form.getFieldValue([[formName], 'started_in'])
                            }
                          />
                        </Control>
                      </Control>

                      <FormItem
                        // rule={[
                        //    { validator: validateStartEndDate }
                        // ]
                        // }
                        name={[[formName], 'ended_in']}
                      />
                    </>
                  )}

                  {workErrorMsg && (
                    <p style={{ color: 'red' }}>{workErrorMsg}</p>
                  )}

                  {isCurrentlyWorking && (
                    <Control flexStart column>
                      <Label> Notice Period (In Days) *</Label>
                      <AntdSelect
                        placeholder="Eg.0-15"
                        name={[[formName], 'noticePeriod']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Notice Period!',
                          },
                        ]}
                        OptionData={NoticePeriodList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => onNoticePeriodChange(value)}
                        value={noticePeriod}
                      />
                    </Control>
                  )}
                </Fragment>
              )}

              {!formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <Label>Start Month*</Label>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'startMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Month!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartMonthChange(value)
                          form.validateFields(
                            [[formName], 'startMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].startMonth.errors[0]
                                    .message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={startMonth}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            .indexOf(input?.toLowerCase()) >= 0
                        }
                        disable={false}
                      />
                    </Control>

                    <Control flexStart column>
                      <Label> Start Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'startYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Year!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartYearChange(value)
                          form.validateFields(
                            [[formName], 'startYear'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].startYear.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={startYear}
                        allowClear={true}
                        showSearch={true}
                        disable={false}
                      />
                    </Control>
                  </Control>

                  <FormItem name={[[formName], 'started_in']} />

                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <Label>End Month*</Label>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'endMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Ended Month!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onEndMonthChange(value)
                          form.validateFields(
                            [[formName], 'endMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].endMonth.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={endMonth}
                        disabled={
                          !form.getFieldValue([[formName], 'started_in'])
                        }
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            .indexOf(input?.toLowerCase()) >= 0
                        }
                      />
                    </Control>
                    <Control flexStart column>
                      <Label> End Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'endYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Ended Year!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onEndYearChange(value)
                          form.validateFields(
                            [[formName], 'endYear'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].endYear.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={endYear}
                        allowClear={true}
                        showSearch={true}
                        filterOption={true}
                        disabled={
                          !form.getFieldValue([[formName], 'started_in'])
                        }
                      />
                    </Control>
                  </Control>

                  {dateErrorMsg && (
                    <p style={{ color: 'red' }}>{dateErrorMsg}</p>
                  )}

                  <FormItem name={[[formName], 'ended_in']} />
                </Fragment>
              )} */}
              </Control>
              {formName?.includes('course') && (
                <Control top="20px" flexStart column>
                  <Label>Course Name *
                    {(() => {
                        return !isNew && pendingFields?.title !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                      })()}
                  </Label>
                  <AntdInput
                    placeholder="Eg.Bharti.."
                    name={[[formName], 'title']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message:
                          'Please enter course name! Minimum 3 characters, Maximum 120 characters.',
                      },
                    ]}
                    onChange={handleInputChange}
                  />
                </Control>
              )}

              {(formName?.includes('experience') || formName?.includes('internship')) && (
                <Control row gap="20px" width="100%">
                  {/* <Control top="20px" flexStart column width="49%">
                    <FormItem name={[[formName], 'function']}>
                      <div></div>
                    </FormItem>
                    <Label>Function *</Label>
                    <FormItem name={[[formName], 'function']} />
                    <FormItem name={[[formName], 'addFunction']} />
                    <AntdSelect
                      rules={[
                        {
                          required: true,
                          message: 'Please select Function!',
                        },
                      ]}
                      placeholder="Eg.Operation"
                      name={[[formName], 'function']}
                      OptionData={optionsFunction || []}
                      valueParam="name"
                      nameParam="name"
                      disabled={frozenFields.function}
                      showSearch={true}
                      onChange={onFunctionChange}
                      value={form?.getFieldValue([[formName], 'function'])}
                      onSearch={data => setFunctionSearch(data?.trim() ?? '')}
                      filterOption={false}
                      onBlur={() => onBlurHandler('function')}
                    />

                  </Control> */}



                  <Control top="20px" flexStart column width="100%">
                    <FormItem name={[[formName], 'industry']}>
                      <div></div>
                    </FormItem>
                    <Label>Industry
                      {(() => {
                        return !isNew && pendingFields?.industry !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                      })()} </Label>
                    <FormItem name={[[formName], 'industry']} />
                    <FormItem name={[[formName], 'addIndustry']} />

                    <AntdSelect
                      rules={[
                        // {
                        //   required: true,
                        //   message: 'Please select industry!',
                        // },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'industry']}
                      OptionData={industrySearchList || []}
                      valueParam="name"
                      nameParam="name"
                      disabled={frozenFields.industry}
                      showSearch={true}
                      onSearch={data => delayIndustryToFetch(data)}
                      onChange={onIndustryChange}
                      value={
                        form.getFieldValue([[formName], 'addIndustry']) ===
                          'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'industry'])
                      }
                      filterOption={false}
                    />
                  </Control>

                </Control>
              )}
              {form.getFieldValue([[formName], 'addIndustry']) ===
                'OTHER' && (
                  <Control top="20px" flexStart column>
                    <Label>Please enter the Industry name</Label>
                    <AntdInput
                      placeholder="Enter the Industry name"
                      name={[[formName], 'industry']}
                      value={form.getFieldValue([[formName], 'industry'])}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the Industry name.',
                        },
                      ]}
                      onChange={e => {
                        // setIsCurrentlyWorking(false)
                      }}
                      onBlur={() => onBlurHandler('industry')}
                    />
                  </Control>
                )}

              {formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>

                      <FormItem rules={[
                        {
                          required: true,
                          message: 'Please select year!',
                        },
                        { validator: validatorEndDate }
                      ]} name={[[formName], 'started_in']}>
                        <Label>
                          Started *
                          {(() => {
                            return !isNew && pendingFields?.started_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                          })()}
                        </Label>
                        <Date
                          style={{ marginTop: '8px' }}

                          placeholder="Please Select the year"
                          onChange={onDateChange}
                          format="MM/YYYY"
                          picker="month"
                          value={startDate && moment(startDate, "MM/YYYY", true).isValid() ? moment(startDate, "MM/YYYY") : null}
                          // value={startDate ? moment(startDate) : null}
                          inputReadOnly
                          disabled={frozenFields.started_in}
                          disabledDate={d => !d || d.isAfter(moment())}
                        />
                      </FormItem>
                    </Control>
                    {isCurrentlyWorking && (
                      <Control flexStart column>
                        <FormItem name={[[formName], 'noticePeriod']}>
                          <div></div>
                        </FormItem>
                        <Label> Notice Period (In Days) *</Label>
                        <AntdSelect
                          placeholder="Eg.0-15"
                          name={[[formName], 'noticePeriod']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select Notice Period!',
                            },
                          ]}
                          OptionData={NoticePeriodList}
                          valueParam="value"
                          nameParam="name"
                          onChange={value => onNoticePeriodChange(value)}
                          value={noticePeriod}
                        />
                      </Control>
                    )}
                    {!isCurrentlyWorking && (
                      <Control flexStart column>

                        <FormItem rules={[
                          {
                            required: true,
                            message: 'Please select year!',
                          },
                        ]} name={[[formName], 'ended_in']}>
                          <Label>
                            Ended *
                            {(() => {
                              return !isNew && pendingFields?.ended_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                            })()}
                          </Label>
                          <Date
                            style={{ marginTop: '8px' }}

                            placeholder="Please Select the year"
                            onChange={onDateChangeEnd}
                            format="MM/YYYY"
                            picker="month"
                            value={endDate && moment(endDate, "MM/YYYY", true).isValid() ? moment(endDate, "MM/YYYY") : null}
                            //value={endDate ? moment(endDate) : null}
                            inputReadOnly
                            disabled={frozenFields.ended_in}
                            disabledDate={d => !d || d.isAfter(moment())}
                          />
                        </FormItem>
                      </Control>
                    )}
                  </Control>

                  <FormItem name={[[formName], 'started_in']} />

                  {(!isPresent || isCurrentlyWorking) && (
                    <Control spaceBetween top="20px" gap="20px">
                      <Control flexStart column></Control>
                      <Control flexStart column>
                        <Checkbox
                          onChange={isCurrentlyOnChange}
                          checked={isCurrentlyWorking}
                        >
                          {'I am currently working'}
                        </Checkbox>
                      </Control>
                    </Control>
                  )}

                  <FormItem name={[[formName], 'isCurrentlyWorking']} />


                  {workErrorMsg && (
                    <p style={{ color: 'red' }}>{workErrorMsg}</p>
                  )}


                </Fragment>
              )}
              {formName?.includes('experience') && (
                <Control top="20px" flexStart column>

                  <Label>Job Type *
                    {(() => {
                                return !isNew && pendingFields?.jobType !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                              })()}
                  </Label>
                  <FormItem
                    name={[[formName], 'jobType']}
                    rules={[
                      {
                        required: true,
                        message: 'Please select the job type',
                      },
                    ]}
                  >
                    <RadioGroupNew
                      onChange={({ target }) =>
                        jobTypeOnchange(target.value)
                      }
                      defaultValue={isJobType}
                    >
                      {RadioOptions?.map((item, index) => (
                        <Radio
                          width={'50%'}
                          key={index}
                          border={true}
                          label={item?.label}
                          value={item?.value}
                        />
                      ))}
                    </RadioGroupNew>
                  </FormItem>
                </Control>
              )}

              {/* {formName?.includes('experience') && (
                <Control top="20px" flexStart column >
                  <Label>Job Title *</Label>
                  <AntdInput
                    placeholder="Eg.Bharti.."
                    name={[[formName], 'title']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message:
                          'Please enter job title! Minimum 3 characters, Maximum 120 characters.',
                      },
                    ]}
                    onBlur={onBlurProjectTitle}
                    onChange={handleInputChange}
                  />
                </Control>
              )} */}
              {!formName?.includes('experience') && !formName?.includes('course') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>


                      <FormItem rules={[
                        {
                          required: true,
                          message: 'Please select year!',
                        },
                        //  { validator: validatorEndDate }
                      ]} name={[[formName], 'started_in']}>
                        <Label>
                          Started *
                          {(() => {
                            return !isNew && pendingFields?.started_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                          })()}
                        </Label>
                        <Date
                          style={{ marginTop: '8px' }}

                          placeholder="Please Select the year"
                          onChange={onDateChange}
                          format="MM/YYYY"
                          picker="month"
                          value={startDate ? moment(startDate, "MM/YYYY") : null}
                          // value={startDate ? moment(startDate) : null}
                          inputReadOnly
                          disabled={frozenFields.started_in}
                          disabledDate={d => !d || d.isAfter(moment())}
                        />
                      </FormItem>
                    </Control>

                    <Control flexStart column>
                      <FormItem rules={[
                        {
                          required: true,
                          message: 'Please select year!',
                        },
                        { validator: validatorEndDate }
                      ]} name={[[formName], 'ended_in']}>
                        <Label>
                          Ended *
                          {(() => {
                              return !isNew && pendingFields?.ended_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                            })()}
                            </Label>
                        <Date
                          style={{ marginTop: '8px' }}

                          placeholder="Please Select the year"
                          onChange={onDateChangeEnd}
                          format="MM/YYYY"
                          picker="month"
                          value={endDate ? moment(endDate, "MM/YYYY") : null}
                          //value={endDate ? moment(endDate) : null}
                          inputReadOnly
                          disabled={frozenFields.ended_in}
                          disabledDate={d => !d || d.isAfter(moment())}
                        />
                      </FormItem>
                    </Control>
                  </Control>


                  {/* 
                  {dateErrorMsg && (
                    <p style={{ color: 'red' }}>{dateErrorMsg}</p>
                  )}

                  <FormItem
                    rule={[
                       { validator: validatorEndDate }
                    ]
                    }
                    name={[[formName], 'ended_in']}
                  /> */}
                </Fragment>
              )}
              {formName?.includes('course') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>


                      <FormItem name={[[formName], 'started_in']}>
                        <Label>
                          Started
                          {(() => {
                            return !isNew && pendingFields?.started_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                          })()}
                        </Label>
                        <Date
                          style={{ marginTop: '8px' }}

                          placeholder="Please Select the year"
                          onChange={onDateChange}
                          format="MM/YYYY"
                          picker="month"
                          defaultValue={startDate ? moment(startDate, "MM/YYYY") : null}
                          // value={startDate ? moment(startDate) : null}
                          inputReadOnly
                          disabledDate={d => !d || d.isAfter(moment())}
                        />
                      </FormItem>
                    </Control>

                    <Control flexStart column>
                      <FormItem rules={[
                        { validator: validatorEndDate }
                      ]} name={[[formName], 'ended_in']}>
                        <Label>Ended
                          {(() => {
                              return !isNew && pendingFields?.ended_in !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                            })()}
                        </Label>
                        <Date
                          style={{ marginTop: '8px' }}

                          placeholder="Please Select the year"
                          onChange={onDateChangeEnd}
                          format="MM/YYYY"
                          picker="month"
                          defaultValue={endDate ? moment(endDate, "MM/YYYY") : null}
                          //value={endDate ? moment(endDate) : null}
                          inputReadOnly
                          disabledDate={d => !d || d.isAfter(moment())}
                        />
                      </FormItem>
                    </Control>
                  </Control>


                  {/* 
                  {dateErrorMsg && (
                    <p style={{ color: 'red' }}>{dateErrorMsg}</p>
                  )}

                  <FormItem
                    rule={[
                       { validator: validatorEndDate }
                    ]
                    }
                    name={[[formName], 'ended_in']}
                  /> */}
                </Fragment>
              )}


              <Control top="20px" flexStart column>
                <Label>
                  Description
                  {(() => {
                    return !isNew && pendingFields?.description !== undefined && <PendingIcon style={{ marginLeft: 6 }} />
                  })()}
                </Label>
                <FormItem
                  name={[[formName], 'description']}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (countRichTextCharacters(value) > 1000) {
                          return Promise.reject(
                            new Error('Maximum 1000 Character allowed!')
                          )
                        }

                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <RichEditor
                    value={description}
                    onChange={onChangeDescription}
                    disabled={frozenFields.description}
                    labelName=""
                    placeholder="Enter Description here..."
                  />
                </FormItem>
                {'Characters: ' +
                  countRichTextCharacters(
                    form.getFieldValue([[formName], 'description'])
                  ) +
                  ' / 1000'}
              </Control>
              <Control top="20px" flexStart column>
                <Label> Skills </Label>
                <AntdSelect
                  placeholder="Eg.React.js"
                  name={[[formName], 'skill_set']}
                  disabled={frozenFields.skill_set}
                  rules={[
                    // {
                    //   validator: async (_, value) => {
                    //     if (
                    //       !selectedSkill?.length &&
                    //       (!Array.isArray(value) || value?.length === 0)
                    //     ) {
                    //       return Promise.reject(
                    //         new Error('Please select skills!')
                    //       )
                    //     }
                    //     return Promise.resolve()
                    //   },
                    // },
                    // {
                    //   validator: validateSkill,
                    // },
                  ]}
                  OptionData={listOfSkills}
                  valueParam="id"
                  nameParam="name"
                  value={selectedSkill}
                  mode="multiple"
                  showSearch={true}
                  onSearch={data => delaySkillToFetch(data)}
                  onClear={() => delaySkillToFetch('')}
                  onChange={(value, id) => onSkillChange(value, id)}
                  filterOption={false}
                  onDropdownVisibleChange={open => {
                    if (!open) {
                      delaySkillToFetch('')
                      form.setFieldsValue({
                        [formName]: { skill_set: storeSkill },
                      })
                    }
                  }}
                />
                {skillErrorMsg && (
                  <p style={{ color: 'red' }}>{skillErrorMsg}</p>
                )}
                {'Skills: ' + selectedSkill?.length + ' / 20'}
              </Control>
              {(formName?.includes('course') || formName?.includes('project') ||
                formName?.includes('internship') || formName?.includes('experience')) && (
                  <Control flexStart column top="20px">
                    <FormItem name={[[formName], 'certificate']} noStyle>
                      <Label>
                        Certificate
                        {(() => {
                          return !isNew && (pendingFields?.certificate !== undefined || pendingFields?.certifications !== undefined) && <PendingIcon style={{ marginLeft: 6 }} />
                        })()}
                      </Label>

                      {file ? (
                        <Control column top="10px" center>
                          <FileReaderVisible
                            file={file}
                            setFile={(val) => {
                              if (frozenFields.certifications) return
                              setFile(val)
                              form.setFieldsValue({
                                [formName]: {
                                  certificate: val,
                                },
                              })
                              setIsUpdateButtonEnabled(false)
                            }}
                          />
                        </Control>
                      ) : (
                        !frozenFields.certifications && (
                          <Control column top="10px" center>
                            <Uploadloader
                              key="certificate-upload"
                              variant="simple"
                              label="Upload Certificate"
                              file={null}
                              setFile={uploadedFile => {
                                setFile(uploadedFile)
                                setIsUpdateButtonEnabled(false)
                                form.setFieldsValue({
                                  [formName]: { certificate: uploadedFile },
                                })
                              }}
                              fileName={`${studentFormData?.firstName
                                ?.toLowerCase()
                                ?.replace(/\s/g, '')}_${getFormName(formName)}_certificate`}
                              onlyDoc={false}
                            />
                          </Control>
                        )
                      )}
                    </FormItem>
                  </Control>
                )}
              {/* {!formName?.includes('experience') && (
                <Control flexStart column top="20px">
                  <FormItem name={[[formName], 'certificate']}>
                    <Label>Certificate </Label>
                    {file && Object.keys(file)?.length > 0 ? (
                      <Control column top="10px" center>
                        <FileReaderVisible
                          file={file}
                          setFile={setFile}
                          setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                        />
                      </Control>
                    ) : (
                      <Control column top="10px" center>
                        <Uploadloader
                          setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                          setFile={setFile}
                          isDefault={true}
                          fileName={
                            studentFormData?.admin?.firstName?.toLowerCase() +
                            '_' +
                            getFormName(formName) +
                            '_certificate'
                          }
                        />
                      </Control>
                    )}
                  </FormItem>
                </Control>
              )} */}
            </>
          </StyledFormItem>
          <br></br>
          {/* {(studentFormData?.student?.isExpCandidate ||
            formName?.includes('experience')) && (
            <>
              <Control top="20px" alignCenter gap="10px">
                <Heading>Rewards & Recogination</Heading>
                <SubHeading>(optional)</SubHeading>
              </Control>
              {!!award?.length &&
                award?.map((obj, idx) => {
                  return (
                    <obj.component
                      key={idx + 'award'}
                      form={form}
                      onRemove={awardHandle}
                      formName={obj?.formName}
                      studentFormData={studentFormData}
                      setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                    />
                  )
                })}
              <div style={{ cursor: 'pointer' }}>
                <Control
                  alignCenter
                  gap="10px"
                  onClick={() => awardHandle(true, false)}
                >
                  <AdjustIcon>
                    <AddIcon />
                  </AdjustIcon>
                  <Text>Add Awards</Text>
                </Control>
              </div>
            </>
          )} */}
        </Container>
      )}
    </>
  )
}

export default ProjectForm

